
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import api from "../context/api";
import { AuthContext } from '../context/AuthContext';
import "../styles/SignupDetails.css";
import axios from "axios";



const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isEighteen, setIsEighteen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { phoneNumber, setPhoneNumber, fullName, setFullName } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleRegister = async () => {
    if (!fullName || !phoneNumber || !phoneNumber.trim() || !password || !confirmPassword) {
      alert("Please fill in all required fields");
      return;
    }

    // Only validate email format if email is provided
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && email.trim() !== "" && !emailRegex.test(email)) {
      alert("Please enter a valid email address");
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }

    if (password.length < 4) {
      alert("Password must be at least 4 characters long");
      return;
    }

    if (!isEighteen) {
      alert("You must confirm that you are 18 years or older to proceed");
      return;
    }

    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "GH");
    if (!phoneNumberObj || !phoneNumberObj.isValid()) {
      alert("Please enter a valid phone number");
      return;
    }
    const formattedPhoneNumber = phoneNumberObj ? phoneNumberObj.format("E.164") : "";

    try {
      setLoading(true);
      
      // Build payload - only include email if it has a value
      const payload = {
        fullName,
        password,
        confirmPassword,
        phoneNumber: formattedPhoneNumber,
        isEighteen,
      };
      
      // Only add email to payload if it's provided
      if (email && email.trim() !== "") {
        payload.email = email.trim();
      }
      
      await api.post("/register", payload);

      setLoading(false);
      navigate("/login");
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 400) {
          const backendMessage = String(error.response.data?.message || "");
          const isPhoneConflict = /phone\s*number.*(in\s*use|exists|already)/i.test(backendMessage);

          if (isPhoneConflict) {
            if (window.confirm("Phone number already exists. Reset the password?")) {
              navigate("/password-reset");
            }
          } else {
            alert(backendMessage || "Invalid registration details.");
          }
        } else {
          alert(error.response.data.message);
        }
      } else {
        alert("An error occurred during registration.");
      }
    }
  };

  return (
<div className="login-container">
      <div className="login-image-top"></div>
      <div className="login-box">
              <h2>Sign Up to get started</h2>

      <div className="signup-form">
        <label>Full Name</label>
        <input
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          autoFocus
        />

        <label>Email Address (Optional)</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value.trim())}
        />

        <label>Password</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value.trim())}
        />

        <label>Confirm Password</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value.trim())}
        />

        <label>Phone Number</label>
        <input
          type="text"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          required
        />

        <div className="checkbox-container">
          <input
            type="checkbox"
            checked={isEighteen}
            onChange={() => setIsEighteen(!isEighteen)}
          />
          <label>Are you 18 years old or above?</label>
        </div>

        <button className="signup-button" onClick={handleRegister} disabled={loading}>
          {loading ? "Signing Up..." : "Sign Up"}
        </button>

        <p className="signin-link">
          Already have an account?{" "}
          <span onClick={() => navigate("/login")} className="link-text">
            Sign In
          </span>
        </p>
        </div>
      </div>
    </div>
  );
};


export default Register;
